// Password policy: 8+ chars with an uppercase letter, a number, and a special
// character. Returns an error string, or null if valid. Mirrors the same
// check on the backend (backend/src/lib/passwordPolicy.js). Applied wherever
// a password is newly set (registration, forgot/reset, admin reset).
export function passwordError(pw) {
  if (typeof pw !== "string" || pw.length < 8) return "Password must be at least 8 characters long.";
  if (!/[A-Z]/.test(pw)) return "Password must include at least one uppercase letter.";
  if (!/[0-9]/.test(pw)) return "Password must include at least one number.";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Password must include at least one special character.";
  return null;
}

export const PASSWORD_HINT = "At least 8 characters, including an uppercase letter, a number, and a special character.";

// Generates a random password that always satisfies passwordError() above.
// Excludes visually ambiguous characters (0/O, 1/l/I) to keep it easy to
// read/type if someone has to enter it by hand.
export function generatePassword(length = 16) {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnopqrstuvwxyz";
  const digits = "23456789";
  const special = "!@#$%^&*-_=+";
  const all = upper + lower + digits + special;

  const randomIndex = (max) => {
    const arr = new Uint32Array(1);
    window.crypto.getRandomValues(arr);
    return arr[0] % max;
  };
  const pick = (chars) => chars[randomIndex(chars.length)];

  const chars = [pick(upper), pick(lower), pick(digits), pick(special)];
  while (chars.length < length) chars.push(pick(all));

  // Fisher-Yates shuffle so the required characters aren't always up front.
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
}
